const initialState = {
    isOpen: false,
    isActive: false,
    story: {},
};
const modalStory = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_STORY':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalStory;
